module.exports = {
  "widget.head": "No downpayment, pay in biweekly",
  "widget.simulation-1": "Biweekly minimum from",
  "widget.simulation-2": "Order amount",
  "widget.simulation-3": "Maximum payment term",
  "widget.simulation-3.1": "biweekly",
  "widget.simulation-4": "it's informative simulation, not an offer",
  "widget.features-1":
    "Effortlessly complete your payment in minutes with a single try!",
  "widget.features-2":
    "up to 30 days to fully repay the credit balance with 0%",
  "widget.features-3":
    "Easily pay with your debit card in comfortable biweekly payments",
  "widget.security":
    "Creditea and its partners guarantee the security of the process.",
  "widget.footer-1": "Buy with credit without downpayment",
  "widget.footer-2": "No credit card needed!",
  "widget.footer-3":
    "Creditea is an online personal loan company that belongs to one of the world's leading financial groups: International Personal Finance PLC. We currently help more than 2.8 million people, and with IPF Digital we have a presence in 9 countries.",
  "creditea-pay-introduction.head-1":
    "Thank you for choosing Creditea as your payment method!",
  "creditea-pay-introduction.simulation-1": "To get your credit you will need:",
  "creditea-pay-introduction.simulation-3": "CURP",
  "creditea-pay-introduction.simulation-4": "Phone number",
  "creditea-pay-introduction.simulation-5": "Debit card",
  "creditea-pay-introduction.simulation-6": "ID card",
  "creditea-pay-introduction.simulation-7":
    "If you are an existing customer, you will only need CURP and phone number.",
  "creditea-pay-introduction.simulation-8": "I have read and accepted",
  "creditea-pay-introduction.simulation-8.1":
    "Términos y condiciones de uso de la página web",
  "creditea-pay-introduction.simulation-details-1": "Order amount",
  "creditea-pay-introduction.simulation-details-2":
    "Estimated installment may amount to",
  "creditea-pay-introduction.simulation-details-3": "*minimum payment biweekly",
  "creditea-pay-introduction.simulation-details-4":
    "The final offer will depend on credit calculations",
  "creditea-pay-introduction.simulation-details-5":
    "Purchasing through Creditea will open you a credit limit of up to $70,000",
  "creditea-pay-introduction.next-step": "It's very easy:",
  "creditea-pay-introduction.next-step-1": "Complete your data",
  "creditea-pay-introduction.next-step-1.1":
    "Provide your data to be able to give you a credit offer.",
  "creditea-pay-introduction.next-step-2": "Accept your credit offer",
  "creditea-pay-introduction.next-step-2.1":
    "You can get a credit line of up to $ 70,000 for this and your next purchases.",
  "creditea-pay-introduction.next-step-3": "Finish your purchase",
  "creditea-pay-introduction.next-step-3.1":
    "Finish the process and enjoy your purchase.",
  "creditea-pay-introduction.security":
    "Creditea and its partners guarantee the security of the process.",
  "creditea-pay-introduction.cta": "Continue",
  "customer-data-basic.title": "Customer Data (Basic)",
  "customer-data-basic.curp": "CURP",
  "customer-data-basic.phone-number": "Phone Number",
  "customer-data-basic.name": "Name",
  "customer-data-basic.surname": "Surname",
  "customer-data-basic.accept": "I accept that my data is processed",
  "customer-data-basic.cta-existing-customer": "Existing customer",
  "customer-data-basic.cta-new-customer": "New customer",
  "otp-check.title": "OTP Check",
  "otp-check.description":
    "A verification code has been sent to you. Please enter it below.",
  "otp-check.code": "Code",
  "otp-check.cta-authenticated-positive": "Authenticated Positive",
  "otp-check.cta-authenticated-negative": "Authenticated Negative",
  "otp-check.cta-not-authenticated": "Not Authenticated",
  "wrong-data-rejection.title": "Wrong Data Rejection",
  "wrong-data-rejection.description": "The code entered is not correct.",
  "wrong-data-rejection.cta-resend-code": "Resend Code",
  "wrong-data-rejection.cta-provide-data-again": "Provide Data Again",
  "wrong-data-rejection.description-too-many-attempts":
    "The maximum number of attempts has been exceeded. Please wait 15 minutes before trying again.",
  "wrong-data-rejection.cta-too-many-attempts": "Too Many Attempts",
  "negative-draw-simulation.title": "Negative Draw Simulation",
  "negative-draw-simulation.description": "Insufficient credit limit.",
  "negative-draw-simulation.cta": "Back to the store",
  "draw-simulation.title": "Draw Simulation",
  "draw-simulation.description":
    "The credit limit is sufficient to make the purchase.",
  "draw-simulation.credit-limit": "Credit limit",
  "draw-simulation.purchase-amount": "Purchase amount",
  "draw-simulation.payment-plan": "Payment plan",
  "draw-simulation.cta-success": "Successful purchase",
  "draw-simulation.cta-error": "Failed purchase",
  "sorry-page.title": "Sorry Page",
  "sorry-page.description":
    "An error occurred and the purchase could not be processed. Please contact customer service.",
  "sorry-page.phone": "Phone",
  "sorry-page.email": "Email",
  "success-page.title": "Success Page",
  "success-page.description":
    "The purchase has been successfully made. You will receive an email with the details of the purchase.",
  "customer-data-detailed.title": "Customer Data (Detailed)",
  "customer-data-detailed.address": "Address",
  "customer-data-detailed.email": "Email",
  "customer-data-detailed.income": "Income",
  "customer-data-detailed.cta": "Send",
  "application-confirmation.title": "Application Confirmation",
  "application-confirmation.description":
    "A verification code has been sent. By entering the code and clicking accept, I give my consent for my data to be verified by the Credit Bureau and I accept the Creditea privacy policies.",
  "application-confirmation.code": "Code",
  "application-confirmation.cta-authenticated-positive":
    "Authenticated Positive",
  "application-confirmation.cta-authenticated-negative":
    "Authenticated Negative",
  "application-confirmation.cta-not-authenticated": "Not Authenticated",
  "offer-available.title": "Offer Available",
  "offer-available.description": "We have an offer available for you.",
  "offer-available.credit-limit": "Credit limit",
  "offer-available.purchase-amount": "Purchase amount",
  "offer-available.payment-plan": "Payment plan",
  "offer-available.cta": "Accept",
  "contract-terms.title": "Contract Terms",
  "contract-terms.description":
    "Please read the contract terms carefully before accepting.",
  "contract-terms.cta": "Accept",
  "debit-card-registration.title": "Debit Card Registration",
  "debit-card-registration.description":
    "You have to include a debit card information.",
  "debit-card-registration.description-loading": "Redirecting...",
  "debit-card-registration.cta-no-income-verification":
    "No Income Verification",
  "debit-card-registration.cta-income-verification": "Need Income Verification",
  "debit-card-registration-form.description-registered": "Registered",
  "debit-card-registration-form.card-number": "Card Number",
  "debit-card-registration-form.cta": "Send",
  "onfido-identification.title": "Onfido Identification",
  "onfido-identification.description":
    "Please use Onfido to verify your identity.",
  "onfido-identification.description-loading": "Redirecting...",
  "onfido-identification-form.title": "Onfido Widget",
  "onfido-identification.cta": "Completed",
  "waiting-page.title": "Waiting Page",
  "waiting-page.description":
    "Please wait while we process your request, this may take a few minutes.",
  "waiting-page.cta-success": "Success",
  "waiting-page.cta-onfido-failed": "Onfido Failed",
  "validations.accept-terms-required":
    "You must accept the terms and conditions",
  "validations.curp-required": "CURP is required",
  "validations.curp-invalid": "CURP is invalid",
  "validations.phone-number-required": "Phone number is required",
  "validations.phone-number-invalid": "Phone number is invalid",
  "validations.accept-privacy-policy-required":
    "You must accept the privacy policy",
  "validations.name-required": "Name is required",
  "validations.surname-required": "Surname is required",
  "validations.accept-required": "You must accept that your data is processed",
  "validations.address-required": "Address is required",
  "validations.email-required": "Email is required",
  "validations.email-invalid": "Email is invalid",
  "validations.income-required": "Income is required",
  "validations.code-required": "The code you entered is incorrect or invalid",
};
